import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Search from "../assets/search.png";

import {
  Box,
  FormControl,
  InputAdornment,
  Modal,
  OutlinedInput,
} from "@mui/material";
import React from "react";

export default function SearchModal({
  open,
  setOpen,
  title,
  searchBoxvalue,
  handlesearch,
}) {
  //   const [] = useState(true);
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      setOpen
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        style={{
          background: "white",
          height: "112px",
          fontSize: "18px",
          margin: "auto",
          padding: "20px",
          paddingLeft: "30px",
        }}
      >
        <Box
          style={{
            fontSize: "18px",
            margin: "auto",
            display: "flex",
            alignItems: "center",
            justifyConent: "center",
            gap: "10px",
            //   align
          }}
        >
          <ArrowBackIosIcon
            fontSize="12px"
            onClick={() => {
              setOpen(false);
            }}
          />{" "}
          {title}
        </Box>
        <Box>
          <FormControl
            sx={{ m: 1, width: "90%", marginTop: "20px" }}
            variant="outlined"
          >
            <OutlinedInput
              type="text"
              placeholder="Search"
              style={{
                width: "100%",
                borderRadius: "5px",
                border: "none",
              }}
              value={searchBoxvalue}
              onKeyUp={(e) => {
                if (e.key == "Enter") {
                  setOpen(false);
                }
              }}
              onChange={(e) => {
                handlesearch(e.target.value);
              }}
              startAdornment={
                <InputAdornment position="start">
                  <img
                    src={Search}
                    style={{ cursor: "pointer" }}
                    width={"24px"}
                    height={"24px"}
                  />
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
      </Box>
    </Modal>
  );
}
